import React from "react"

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
} from "@mui/material"

import {
    t,
    Trans,
} from "@lingui/macro"

import { DateTime } from "luxon"
import { UseFormReturn } from "react-hook-form"

import {
    MatesDatePicker,
    withUseFormHook,
} from "@sinossi/mates-react-library"

import { Action } from "models"

import DeferActionValidation from "./form"


interface DeferActionProps extends UseFormReturn
{
    openDialog: boolean
    onClose: () => void
    submit: (value: any) => void
    data: Action
}
interface DeferActionState
{
}
class DeferAction extends React.Component<DeferActionProps, DeferActionState>
{
    componentDidMount()
    {
        const dateTime = DateTime.fromISO(this.props.data.deadline)
        this.props.setValue("deadline", dateTime)
    }

    render()
	{
        return (
            <Dialog open={this.props.openDialog} onClose={this.props.onClose}>
                <Typography variant="h5" sx={{ml: 2, mt: 2}}>
                    <Trans id={'workflow.defer-action.title'}>
                        Posticipa azione
                    </Trans>
                </Typography>
                <form onSubmit={this.props.handleSubmit(this.props.submit)}>
                    <DialogContent>
                        <MatesDatePicker label={t({
                            id: "workflow.defer-action-date",
                            message: "Data",
                        })}
                            name="deadline"
                            control={this.props.control}
                            trigger={this.props.trigger}
                            formState={this.props.formState}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.props.onClose}
                                variant={"contained"}
                                color="neutral"
                                sx={{
                                    textTransform: "none",
                                    mr: 1,
                                    width: 100
                                }}
                                disableElevation>
                            <Trans id={"workflow.template.new-template.abort"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button type="submit"
                                variant="contained"
                                sx={{
                                    backgroundColor: 'secondary.main',
                                    color: 'white',
                                    mr: 1,
                                    textTransform: "none",
                                    width: 100
                                }}
                        >
                            <Trans id={"workflow.template.new-step.save"}>
                                Salva
                            </Trans>
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        )
    }
}

export default withUseFormHook<{}>(
    DeferAction,
    DeferActionValidation,
    {}
)
